import React from 'react';

export default function Avatar({ name, size = 'md', color = 'indigo' }) {
  const initials = name
    ?.split(' ')
    .map((n) => n[0])
    .join('')
    .substring(0, 2) || '??';
  const sizes = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-12 h-12 text-sm',
    lg: 'w-16 h-16 text-xl'
  };
  const colors = {
    indigo: 'bg-[#e8e8ed] text-[#1d1d1f]',
    slate: 'bg-[#e0e0e5] text-[#1d1d1f]',
    rose: 'bg-[#f0e7e7] text-[#1d1d1f]'
  };

  return (
    <div
      className={`${sizes[size]} ${colors[color] || colors.indigo} rounded-full flex items-center justify-center font-semibold flex-shrink-0`}
      aria-label={name}
    >
      {initials}
    </div>
  );
}
